import { ValidateSslRequest, ValidateSslResponse } from "@shared/types/common";
import { DateTime } from "luxon";

import json from "../../json/cdn/validateSsl.json";

export default async (data?: object) => {
  const request = data as ValidateSslRequest;

  const response = JSON.parse(
    JSON.stringify(await json),
  ) as ValidateSslResponse;
  return {
    ...response,
    expiry: DateTime.now().plus({ years: 1 }).toMillis(),
    certificate_name: request.certificate_name,
  } satisfies ValidateSslResponse;
};
